import { Icon, Text } from "@shopify/polaris"
import { ArrowRightIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import { useTranslation } from "react-i18next"

import stores from "@/stores"

import styles from "./DiscountModule.module.scss"

type Variant = "headingXs" | "headingSm" | "headingMd" | "headingLg" | "headingXl" | "heading2xl" | "heading3xl" | "bodyXs" | "bodySm" | "bodyMd" | "bodyLg";
interface DiscountModuleProps {
  titleVariant?: Variant
  showButton?: boolean
  classNames?: string
}
export const DiscountModule = ({
  titleVariant = "headingMd",
  showButton = true,
}: DiscountModuleProps) => {
  const { t } = useTranslation("common")
  const DiscountModuleText = {
    title: t("DiscountTitleNew"),
    description: t("DiscountDescription"),
    buttonText: t("DiscountButton"),
  }
  const { userInfoSore } = stores
  const { banner_discount_v2024_04: { discount_tier } } = userInfoSore.data

  if (discount_tier === "tms_100_off_first_month") {
    DiscountModuleText.title = t("TMSDiscountTitle")
    DiscountModuleText.description = t("TMSDiscountDescription100")
    DiscountModuleText.buttonText = t("TMSDiscountButtonText100")
  } else if (discount_tier === "tms_50_off_first_month"){
    DiscountModuleText.title = t("TMSDiscountTitle")
    DiscountModuleText.description = t("TMSDiscountDescription")
    DiscountModuleText.buttonText = t("TMSDiscountButtonText")
  }

  const { title, description, buttonText } = DiscountModuleText

  return <div className={classNames("absolute text-white", showButton ? "p-4" : "pt-6 pl-[48px]", styles.wrapper, classNames)}>
    <Text as={"h3"} variant={titleVariant}>{title}</Text>
    <div className={showButton ? "mt-2" : "mt-4"}></div>
    <Text as={"p"} variant={"bodyMd"}>{description}</Text>
    {
      showButton && <div className={"inline-block mt-5"}>
        <div className={"flex gap-2 items-center rounded-full px-5 py-1.5 bg-[#1274FF] h-10 text-base font-semibold"}>
          {buttonText}
          <Icon source={ArrowRightIcon} />
        </div>
      </div>
    }
  </div>
}
